import { Vector3 } from "three";
import { MeasurementManager } from "../MeasurementManager";

export interface IMeasurementCommand {
  execute(): void;
  clone(): IMeasurementCommand;
}

export interface ISetPointsCommandPayload {
  id: number;
  points: Vector3[];
}

export class SetMeasurementPointsCommand implements IMeasurementCommand {
  private _measurementManager: MeasurementManager;
  private _payload: ISetPointsCommandPayload;

  constructor(
    measurementManager: MeasurementManager,
    payload: ISetPointsCommandPayload
  ) {
    this._measurementManager = measurementManager;
    this._payload = payload;
  }

  public execute(): void {
    this._measurementManager.setPoints(this._payload.id, this._payload.points);
  }

  public clone(): IMeasurementCommand {
    return new SetMeasurementPointsCommand(this._measurementManager, {
      id: this._payload.id,
      points: this._payload.points.map((p) => p.clone())
    });
  }
}

export class MeasurementCommandHistory {
  private _undoStack: IMeasurementCommand[];
  private _redoStack: IMeasurementCommand[];
  private _current?: IMeasurementCommand;

  constructor() {
    this._undoStack = [];
    this._redoStack = [];
  }

  public add(c: IMeasurementCommand) {
    if (this._current) {
      this._undoStack.push(this._current);
    }
    this._current = c;
    this._redoStack.length = 0;
  }

  public getUndoCommand(): IMeasurementCommand | undefined {
    const undoCommand = this._undoStack.pop();
    if (undoCommand) {
      if (this._current) {
        this._redoStack.push(this._current);
      }
      this._current = undoCommand;
    }
    return undoCommand;
  }

  public getRedoCommand(): IMeasurementCommand | undefined {
    const redoCommand = this._redoStack.pop();
    if (redoCommand) {
      if (this._current) {
        this._undoStack.push(this._current);
      }
      this._current = redoCommand;
    }
    return redoCommand;
  }

  public clear() {
    this._undoStack.length = 0;
    this._redoStack.length = 0;
    this._current = undefined;
  }
}
